import type { FC } from 'react';
import cx from 'classnames';

import { LockClosedIcon } from '@motorway/mw-highway-code';

import styles from './DynamicPlaceholder.module.scss';

interface DynamicPlaceholderProps {
	className?: string;
	text: string;
}

export const DynamicPlaceholder: FC<DynamicPlaceholderProps> = ({ className, text }) => {
	return (
		<div className={cx(styles.container, className)}>
			<span>{text}</span>
			<div className={styles.lockIcon}>
				<LockClosedIcon size="xsmall" />
			</div>
		</div>
	);
};
